import React from 'react';
import {
    Popover,
    Grid,
    Typography,
} from '@mui/material';

const AppsMenu = ({ 
    open, 
    anchorEl, 
    onClose, 
    apps 
}) => {
    return (
        <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'right',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            PaperProps={{
                sx: {
                    p: 1,
                    minWidth: '200px',
                    maxWidth: '400px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                },
            }}
        >
            <Grid 
                container 
                spacing={2}
                justifyContent="center"
                alignItems="center"
            >
                {apps.map((app) => (
                    <Grid 
                        item 
                        xs={4}
                        key={app.name}
                        sx={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <a 
                            href={app.path}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ 
                                textDecoration: 'none',
                                color: 'inherit',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                padding: '0px',
                                borderRadius: '8px',
                                transition: 'all 0.2s ease-in-out',
                                cursor: 'pointer',
                                backgroundColor: '#ffffff',
                                '&:hover': {
                                    backgroundColor: '#f8f9fa',
                                    transform: 'translateY(-2px)',
                                    boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                                }
                            }}
                        >
                            <img 
                                src={app.icon} 
                                alt={app.name} 
                                style={{ 
                                    width: '85px',
                                    height: '40px',
                                    marginBottom: '0px',
                                    objectFit: 'contain'
                                }} 
                            />
                            <Typography
                                variant="caption"
                                sx={{
                                    textAlign: 'center',
                                    fontSize: '13px',
                                    fontWeight: 600,
                                    whiteSpace: 'nowrap',
                                    color: '#1f384c'
                                }}
                            >
                                {app.name}
                            </Typography>
                        </a>
                    </Grid>
                ))}
            </Grid>
        </Popover>
    );
};

export default AppsMenu; 